const DEFAULT_ADS_ID = 'AW-17766153438'

declare global {
  interface Window {
    gtag?: (...args: any[]) => void
  }
}

const GOOGLE_ADS_ID = import.meta.env.VITE_GADS_ID || DEFAULT_ADS_ID
const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-CEZ2GZXFZ1'
const GADS_CONVERSION_ID =
  import.meta.env.VITE_GADS_CONVERSION || 'AW-17766153438/g7SCCLbSxcgbEN75x5dC'

const getGtag = () => (typeof window !== 'undefined' ? window.gtag : undefined)

export const trackPageView = (path: string) => {
  const gtag = getGtag()
  if (!gtag) return
  if (GA_MEASUREMENT_ID) {
    gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
    })
  }
  if (GOOGLE_ADS_ID) {
    gtag('event', 'page_view', {
      send_to: GOOGLE_ADS_ID,
      page_path: path,
    })
  }
}

export const sendGtagEvent = (eventName: string, params?: Record<string, unknown>) => {
  const gtag = getGtag()
  if (!gtag || !GA_MEASUREMENT_ID) return
  gtag('event', eventName, {
    send_to: GA_MEASUREMENT_ID,
    ...params,
  })
}

export const sendAdsConversion = ({
  transactionId,
  value,
  currency,
}: {
  transactionId: string | number
  value?: number
  currency?: string
}) => {
  const gtag = getGtag()
  if (!gtag || !GADS_CONVERSION_ID) return
  gtag('event', 'conversion', {
    send_to: GADS_CONVERSION_ID,
    transaction_id: transactionId,
    value,
    currency,
  })
}
